import { Badge } from '@/components/ui/badge.jsx';

// THE TEST BADGE (David 2026-10-31: "an account or deal page that is test opens with a clear TEST badge"). The server decides
// test (services/test-data.service.js, the one predicate) and sends is_test: true, false, or null when it could not check.
// The word carries the meaning, never the colour alone. Renders nothing for a real record.
export default function TestBadge({ isTest, className = '' }) {
  if (isTest === true) {
    return (
      <Badge
        variant="warning"
        data-test-badge="test"
        title="Test data: hidden from every list, queue, report and cron"
        className={`border border-warning/50 font-bold uppercase tracking-[0.08em] ${className}`}
      >
        Test
      </Badge>
    );
  }
  if (isTest === null) {
    return (
      <Badge variant="outline" data-test-badge="unknown" title="TRACON could not check whether this record is test data" className={className}>
        Test check failed
      </Badge>
    );
  }
  return null;
}
